import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconToolsSWellSizeM from './IconToolsSWell_size_m';

const props: CreateIconArguments = {
  l: IconToolsSWellSizeM,
  m: IconToolsSWellSizeM,
  s: IconToolsSWellSizeM,
  xs: IconToolsSWellSizeM,
  name: 'IconToolsSWell',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'multiple',
};

export default props;
